<template>
  <div>
    <component :is="currentPage"></component>
  </div>
</template>

<script>
import ThirdPartySharingListZHCN from './zh-CN/ThirdPartySharingList.vue';
import ThirdPartySharingListEN from './en/ThirdPartySharingList.vue';

export default {
  data() {
    return {
      currentPage: null,
    };
  },
  created() {
    const userLang = navigator.language || 'en';  // 获取浏览器的语言
    if (userLang.startsWith('zh')) {
      this.currentPage = ThirdPartySharingListZHCN;  // 如果是中文，加载中文版页面
    } else {
      this.currentPage = ThirdPartySharingListEN;  // 如果是英文，加载英文版页面
    }
  },
};
</script>



// WEBPACK FOOTER //
// src/components/ThirdPartySharingList.vue